/**
 * Alaska: App.js (PWA)
 * Store: Modal
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.store("modal", {
        visible: false,
        content: {
            image: "",
            text: "",
            document: ""
        },
        zoom: 1.5,
        canvas_selector: "#modal-document",
        fullscreen_active: false,

        open(data = {}) {
            this.content.image = "";
            this.content.text = "";
            this.content.document = null;

            if (data.image) this.content.image = data.image;
            if (data.text) this.content.text = data.text;
            if (data.document) this.content.document = data.document;

            this.visible = true;
            Debug.log("[MODAL] Opened", this.content);
        },

        close() {
            this.visible = false;

            // Clear canvas
            const canvas = document.querySelector(this.canvas_selector);
            if (canvas) {
                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                canvas.width = 0;
                canvas.height = 0;
            }

            // Explicitly destroy previous PDF instance
            if (this.pdf_instance) {
                this.pdf_instance.destroy().catch(console.warn);
                this.pdf_instance = null;
            }

            this.content.image = "";
            this.content.text = "";
            this.content.document = null;

            Debug.log("[MODAL] Closed");
        },

        async render_document() {
            if (!this.visible || !this.content.document) return;

            const canvas = document.querySelector(this.canvas_selector);
            if (!canvas) return;

            // Clear canvas
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = 0;
            canvas.height = 0;

            // Load new PDF
            const loading_task = pdfjsLib.getDocument(this.content.document);
            const pdf = await loading_task.promise;
            const page = await pdf.getPage(1);

            const context = canvas.getContext("2d");
            const viewport = page.getViewport({ scale: this.zoom });

            canvas.width = viewport.width;
            canvas.height = viewport.height;

            await page.render({ canvasContext: context, viewport }).promise;
        },

        fullscreen() {
            const el = document.querySelector(this.canvas_selector);
            if (!el) return;

            if (!document.fullscreenElement) {
                el.requestFullscreen()
                .then(() => {
                    this.fullscreen_active = true;
                })
                .catch(err => console.error("Fullscreen failed", err));
            } else {
                document.exitFullscreen()
                .then(() => {
                    this.fullscreen_active = false;
                });
            }
        }
    });
});